import {
  ASSETS_ROOT,
  ADD_ASSET,
  ADD_DOCUMENT,
  GET_DOCUMENTS,
  GENERATE_REGISTRATIONS,
  GENERATE_STARTLIST,
  DELETE_DOCUMENT,
  // GET_ASSET,
} from './config';

export async function addAsset(data) {
  const url = ADD_ASSET;
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
      return err.message;
    });

  return result;
}

export async function addDocument(data) {
  const url = ADD_DOCUMENT;
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    body: data,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 400) {
        return res.json();
      } else {
        throw new Error('Could not add asset!');
      }
    })
    .then((data) => {
      return data.statusCode;
    })
    .catch((err) => {
      //console.error(err);
      return err.message;
    });

  return result;
}

export async function getDocuments(competitionId, type) {
  const url = GET_DOCUMENTS.replace('{competitionId}', competitionId).replace(
    '{type}',
    type
  );
  const token = localStorage.getItem('token');

  const documents = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta dokument');
      }
    })
    .then((data) => {
      return data.documents;
    })
    .catch((err) => {
      //console.error(err);
    });

  return documents;
}

export async function generateRegistrations(competitionId) {
  const url = GENERATE_REGISTRATIONS;
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ competitionId: competitionId }),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.blob();
      } else {
        throw new Error('Could not generate registrations');
      }
    })
    .then((blob) => {
      return blob;
    })
    .catch((err) => {
      return err.message;
    });

  return result;
}

export async function generateStartlist(competitionId) {
  const url = GENERATE_STARTLIST;
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ competitionId: competitionId }),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.blob();
      } else {
        throw new Error('Could not generate startlist');
      }
    })
    .then((blob) => {
      return blob;
    })
    .catch((err) => {
      return err.message;
    });

  return result;
}

export async function openPdf(fileUrl) {
  const url = ASSETS_ROOT + fileUrl;
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.blob();
      } else {
        throw new Error('Could not fetch document');
      }
    })
    .then((blob) => {
      return blob;
    })
    .catch((err) => {
      //console.error(err);
      return err.message;
    });

  return result;
}

export async function deleteDocument(id) {
  const url = DELETE_DOCUMENT.replace('{documentId}', id);
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte ta bort dokument');
      }
    })
    .then((data) => {
      return data.statusCode;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

/*
export async function getAsset(id, type) {
  const url = GET_ASSET.replace(
    '{organizerId}',
    id
  ).replace('{asset}', type);

  const asset = await fetch(url)
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta tillgång');
      }
    })
    .then((data) => {
      return data.base64String;
    })
    .catch((err) => {
      console.error(err);
    });

  return asset;
}
*/
